export type ConsentRequestDetails = {
  artifactCode: string;
};

const from = ({ artifactCode }: ConsentRequestDetails): ConsentRequestDetails => ({
  artifactCode,
});

export const ConsentRequestDetails = {
  from,
};
